import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const routes = {
  signup: '/signup',
  login: '/login',
  loginRecover: '/login/recover',
  loginAccess: '/access',
  invitation: '/signup-invitation',
  logout: '/logout',
  summary: '/summary',
  creditcard: '/new/payment/creditcard',
  paymentdata: '/payment',
  newOrder: '/new-order',
  newOrderCatalog: '/new-order-catalog',
  billing: '/billing',
  orders: {
    default: '/orders',
    previous: '/orders/previous',
    active: '/orders/active',
    search: '/orders/search',
    recurring: '/orders/recurring',
  },
  settings: '/settings',
  addresses: '/addresses',
  campaign: '/campaign',
  organizationMembers: '/organization-members',
  tracking: '/tracking',
  analytics: '/dashboard/analytics',
  sustainability: '/dashboard/sustainability',
  dashboard: '/dashboard',
  emergencies: '/emergencies',
  profile: '/profile',
  default: getTenantPreLoginConfig().login_redirect,
};

export default routes;
